import React, { useState, useEffect } from "react";

const AutoComplete = ({
  fetchData,
  onSelect,
  onAdd,
  onView, // 🔹 opcional
  txtLabel,
  initialValue,
  disabled,
}) => {
  const [query, setQuery] = useState(initialValue?.label || "");
  const [selectedItem, setSelectedItem] = useState(initialValue || null);
  const [results, setResults] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    if (initialValue?.label !== query) {
      setQuery(initialValue?.label || "");
      setSelectedItem(initialValue || null);
    }
  }, [initialValue]);

  useEffect(() => {
    if (query.trim() === "") {
      setResults([]);
      setShowDropdown(false);
      setSelectedItem(null);
      if (selectedItem !== null) {
        onSelect(null);
      }
      return;
    }

    if (selectedItem && selectedItem.label === query) {
      setShowDropdown(false);
      return;
    }

    const timeout = setTimeout(async () => {
      const data = await fetchData(query);
      setResults(data);
      setShowDropdown(data.length > 0);
    }, 500);

    return () => clearTimeout(timeout);
  }, [query, fetchData]);

  const handleSelect = (item) => {
    setQuery(item.label);
    setSelectedItem(item);
    setShowDropdown(false);
    onSelect(item);
  };

  const handleBlur = () => {
    setTimeout(() => setShowDropdown(false), 200);
  };

  return (
    <div className="position-relative w-100">
      <div className="form-floating" >
        <input
          disabled={disabled}
          type="text"
          className={`form-control ${onView ? "pe-5" : ""}`} // 🔹 só adiciona espaço se o olhinho existir
          id="autocompleteInput"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onFocus={() => setShowDropdown(results.length > 0)}
          onBlur={handleBlur}
          placeholder="Buscar..."
        />
        <label htmlFor="autocompleteInput">{txtLabel}</label>

        {/* 🔹 Botão “+” para adicionar novo */}
        {results.length === 0 && query.trim() !== "" && !selectedItem && (
          <button
            type="button"
            className="btn btn-primary position-absolute end-0 top-0 mt-2 me-2"
            onClick={onAdd}
          >
            <i className="fas fa-plus"></i>
          </button>
        )}

        {/* 🔹 Mostra o “olhinho” só se houver item selecionado e a prop onView foi informada */}
        {onView && selectedItem && (
          <button
            type="button"
            className="btn btn-outline-secondary position-absolute end-0 top-0 mt-2 me-2"
            onClick={() => onView(selectedItem)}
            title="Ver detalhes"
          >
            <i className="fas fa-eye"></i>
          </button>
        )}
      </div>

      {/* 🔹 Lista de resultados */}
      {showDropdown && query.trim() !== "" && selectedItem?.label !== query && (
        <ul
          className="list-group position-absolute w-100 mt-1 shadow bg-white"
          style={{ zIndex: 1000 }}
        >
          {results.map((item, index) => (
            <li
              key={index}
              className="list-group-item list-group-item-action"
              onClick={() => handleSelect(item)}
              style={{ cursor: "pointer" }}
            >
              {item.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AutoComplete;
